import { OptionProps, components } from 'react-select';
import { KeyboardEventHandler, MouseEventHandler } from 'react';
import { Checkbox } from '../../checkbox/checkbox';
import { Picto } from '../../picto/picto';
import { Radio } from '../../radio/radio';
import { RadioIndicator } from '../../radio/radio-indicator/radio-indicator';
import styles from '../combobox.module.scss';
import { ComboboxOptions, isOptionWithColorSample, isOptionWithPicto } from '../types';

export const Option = (props: OptionProps<ComboboxOptions[0], boolean>) => {
  const { children, isSelected, isFocused, isMulti, data } = props;

  // prevents checkbox from being focused and thus closing the menu for multi selection
  // credits: https://github.com/JedWatson/react-select/issues/4666#issuecomment-933892772
  const onClickMultiOption: MouseEventHandler<HTMLDivElement> = (e) => {
    props.selectOption({ ...data });
    e.stopPropagation();
    e.preventDefault();
  };

  const onKeyDown: KeyboardEventHandler<HTMLDivElement> = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      props.selectOption({ ...data });
      e.stopPropagation();
      e.preventDefault();
    }
  };

  return (
    <components.Option {...props}>
      {isMulti ? (
        <div role="button" tabIndex={0} onClick={onClickMultiOption} onKeyDown={onKeyDown}>
          <Checkbox checked={isSelected} focused={isFocused}>
            {children}
          </Checkbox>
        </div>
      ) : (
        <Radio checked={isSelected} focused={isFocused} indicator={<RadioIndicator />}>
          {children}
        </Radio>
      )}
      {isOptionWithColorSample(props.data) ? (
        <>
          <div className={styles.divider} />
          <div
            className={styles.colorSample}
            style={{ '--igp-combobox-color-sample-bg': props.data.colorSampleHexCode }}
          />
        </>
      ) : null}
      {isOptionWithPicto(props.data) ? (
        <>
          <div className={styles.divider} />
          <Picto className={styles.picto} pictoSrc={props.data.pictoSrc} size="24" />
        </>
      ) : null}
    </components.Option>
  );
};
